import { Text, type TextStyle } from 'react-native'

import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Label = styled(Text, theme => {
  const baseFontWeight = String(
    theme.fontWeightRegular
  ) as TextStyle['fontWeight']

  const semiboldFontWeight = String(
    theme.fontWeightSemibold
  ) as TextStyle['fontWeight']

  return {
    base: {
      flexShrink: 1,
      textAlign: 'left',
      fontFamily: theme.fontFamily.regular,
      fontWeight: baseFontWeight,
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      color: theme.colorTextNeutralDefault,
    },
    variants: {
      size: {
        md: {
          fontSize: theme.fontSizeThreepulse,
          lineHeight: convertLineHeight(
            theme.fontSizeThreepulse,
            theme.lineHeightMedium
          ),
        },
        ml: {
          fontSize: theme.fontSizeThreeandhalfpulse,
          lineHeight: convertLineHeight(
            theme.fontSizeThreeandhalfpulse,
            theme.lineHeightSmall
          ),
        },
        lg: {
          fontSize: theme.fontSizeFourpulse,
          lineHeight: convertLineHeight(
            theme.fontSizeFourpulse,
            theme.lineHeightSmall
          ),
        },
        xl: {
          fontSize: theme.fontSizeFourpulse,
          lineHeight: convertLineHeight(
            theme.fontSizeFourpulse,
            theme.lineHeightSmall
          ),
        },
      },
      hasError: {
        true: {
          fontWeight: semiboldFontWeight,
        },
      },
      hasDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
      hasReadOnly: {
        true: {
          color: theme.colorTextNeutralReadonly,
        },
      },
    },
  }
})
